export enum EmbedType {
    DEFAULT             = 1,
    YOUTUBE             = 2,
    FIGMA               = 3,
    GOOGLE_CALENDAR     = 4,
    GOOGLE_DOC          = 5,
    GOOGLE_SHEET        = 6,
    GOOGLE_SLIDES       = 7,
    FACEBOOK            = 8,
    TWITTER             = 9,
    GOOGLE_MAP          = 10,
}
